// extracted by mini-css-extract-plugin
export default {"title":"styles_title__0Zn3h","inputNumber":"styles_inputNumber__dhK6Q","containerInputNumber":"styles_containerInputNumber__L87Rg"};